'use client';
import verificationPrivate from '@bells/api/verification/private';
import { useAuth } from '@bells/core/auth';
import { AuthedUser } from '@bells/schema/models/auth';
import { Button } from '@bells/ui/components/button';
import { useMemo } from 'react';
import { useLanguage } from '@bells/core/i18n';
import { generateRestClient } from '@bells/core/rest/react';
import { MESSAGES } from '@veriff/incontext-sdk';
import { AttendantProfileState } from '@bells/schema/models/attendant';
import {
  attendantVerificationAlertTitle,
  attendantVerificationAlertSubmit,
} from '@bells/i18n';
import { ArrowRight, CircleAlert } from 'lucide-react';
const checkVisibility = (currentUser?: AuthedUser) => {
  const profliles = (currentUser?.attendants ?? []).map(
    (df) => df.state == AttendantProfileState.ON_VERIFICATION
  );
  return profliles.length > 0;
};

export default function VerificationModal() {
  const { currentUser } = useAuth();
  const privateClient = generateRestClient(verificationPrivate);
  const { language } = useLanguage();
  const isVisible = useMemo(() => {
    return checkVisibility(currentUser);
  }, [currentUser]);

  const loadVeriffSDK = async (sessionUrl: string) => {
    const importedModule = await import('@veriff/incontext-sdk');
    importedModule.createVeriffFrame({
      url: sessionUrl,
      embedded: false,
      lang: language,
      onEvent: (e: MESSAGES) => {
        console.log('onEvent', e);
      },
    });
  };

  const verify = async () => {
    const data = await privateClient.verify.query({ query: {} });
    if (data.status !== 200) {
      return;
    }
    loadVeriffSDK(data.body.sessionUrl);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className='dark top-0 z-10 flex h-12 items-center justify-between bg-orange-400 text-white transition-all duration-300 ease-in-out'>
      <div className='mx-auto my-0 flex w-full max-w-screen-xl items-center justify-between gap-4 overflow-hidden px-4 py-2 text-sm lg:px-8'>
        <div className='flex flex-1 items-center justify-center gap-2'>
          <CircleAlert className='mr-1 hidden h-5 w-5 lg:block'></CircleAlert>
          <div className='inline-block'>
            {attendantVerificationAlertTitle()}
          </div>
          <ArrowRight className='hidden lg:inline-block'></ArrowRight>
          <Button onClick={() => verify()} size={'xs'}>
            {attendantVerificationAlertSubmit()}
          </Button>
        </div>
      </div>
    </div>
  );
}
